module.exports = __webpack_public_path__ + "static/blue-square-30e6ea2461301b282fbee32b25f6a4ec.png";